<template>
  <div class="wrap-box">
    <div class="top-box">
      <div class="content-box">
        <!-- 电子工单 -->
        <div class="card-box card-padding">
          <div
            class="card-title card-title-flex"
            @click="goWorkOrders"
          >
            <div
              class="card-flex"
            >
              <img
                class="takeImg"
                src="@/assets/img/take_photo.png"
                alt=""
              >电子工单
            </div>
            <div>
              <span
                class="stateInfo"
                :class="{ isStateInfo: !isPerfection}"
              >{{ isPerfection ? '已完善' : '未完善' }}</span>
              <van-icon name="arrow" />
            </div>
          </div>
        </div>
        <!-- 放空照片详情 -->
        <div class="card-box card-padding">
          <div
            class="card-title card-title-flex"
          >
            <div class="">
              <span>放空照片详情</span>
              <span class="card-tips card-tips__red">（缺失{{ (imageInfo.photoNumAll || 0)-(imageInfo.photoNumTaked || 0) }}张照片）</span>
            </div>
            <div class="card-title-info">
              <span>{{ imageInfo.photoNumTaked || 0 }}/{{ imageInfo.photoNumAll || 0 }}</span>
              <van-icon name="arrow" />
            </div>
          </div>
          <van-button
            type="info"
            size="large"
            @click="toPhoto"
          >去拍照</van-button>
        </div>
        <!-- 放空原因 -->
        <div class="card-box card-padding">
          <div class="card-title card-title-flex">
            <div class="">
              <span>放空原因</span>
              <span class="card-tips card-tips__red">（必填）</span>
            </div>
          </div>
          <van-divider style="margin: 16px -16px;" />
          <ReasonSelectBox
            ref="reasonSelectBox"
            title="请选择对应的放空原因"
            :data-list="reasonDataList"
            :value.sync="dataForm.evacuationReason"
            placeholder="请输入放空原因"
            :maxlength="255"
          />
        </div>
        <!-- 确认弹窗 -->
        <ConfirmDialog
          ref="confirmDialog"
        />
      </div>
    </div>
    <div class="bottom-box">
      <!-- 底部滑动条 -->
      <ClickButton
        ref="clickButton"
        @sliderCompleted="sliderCompleted"
      >
        点击确认放空
      </ClickButton>
    </div>
  </div>
</template>

<script>
import ClickButton from '@/components/clickButton.vue';
import ConfirmDialog from '@/components/confirmDialog.vue';
import ReasonSelectBox from './components/reasonSelectBox.vue';
import jsApi from '@/common/jsApi';
import {
  queryDictByCodes
} from '@/common/api.js';
import {
  checkPictureNum,
  savePictureTemplate,
  rescueResult,
  getRescueReport
} from '@/common/apiPaic.js';

const initDataForm = () => {
  return {
    evacuationReason: ''
  };
};

export default {
  components: {
    ClickButton,
    ConfirmDialog,
    ReasonSelectBox
  },
  data() {
    return {
      dataForm: initDataForm(),
      reasonDataList: [],
      imageInfo: {},
      orderNo: '',
      taskNo: '',
      appServiceType: '',
      useTraceCar: 0,
      productCategoryName: '',
      workerName: '',
      hasUnderGround: false,
      imageCompleted: false,
      reportData: {}
    };
  },
  computed: {
    // 是否完善
    isPerfection() {
      return this.reportData && this.reportData.operatorSign && this.reportData.carStatus;
    }
  },
  created() {
    const {
      orderNo,
      taskNo
    } = this.$route.params;
    if (orderNo && taskNo) {
      this.orderNo = orderNo;
      this.taskNo = taskNo;
    }
    const {
      appServiceType,
      useTraceCar,
      productCategoryName,
      workerName,
      hasUnderGround
    } = this.$route.query;
    this.appServiceType = appServiceType;
    this.useTraceCar = useTraceCar;
    this.productCategoryName = productCategoryName;
    this.workerName = workerName;
    this.hasUnderGround = hasUnderGround;
    // 定义提供给原生调用的方法
    window.webViewDidAppear = () => {
      this.checkPictureNum();
    };
  },
  activated() {
    this.getRescueReport();
  },
  mounted() {
    this.queryDictByCodes();
    this.checkPictureNum();
  },
  methods: {
    async getRescueReport() {
      try {
        const data = await getRescueReport({
          orderNo: this.orderNo,
          taskNo: this.taskNo
        });
        if (data) {
          this.reportData = data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    goWorkOrders() {
      this.$router.push({
        name: 'WorkOrders',
        params: {
          orderNo: this.orderNo,
          taskNo: this.taskNo
        },
        query: {
          isH5: true,
          type: 'evacuation'
        }
      });
    },
    // 滑动到底
    async sliderCompleted() {
      if (!this.imageCompleted) {
        this.showImageInfo();
        return;
      }
      if (!this.dataForm.evacuationReason) {
        this.showRequiredInfo();
        return;
      }
      if (this.$refs.reasonSelectBox) {
        const result = await this.$refs.reasonSelectBox.validate();
        console.log(result);
        if (!result) {
          this.$refs.clickButton.reset();
          return;
        }
      }
      console.log(this.dataForm);
      try {
        this.showInfoConfirm();
      } finally {
        this.$refs.clickButton.reset();
      }
    },
    showImageInfo() {
      const confirmText = this.imageInfo.requiredTips || '图片缺失';
      this.$refs.confirmDialog.open({
        confirmText,
        showCancelButton: false,
        confirmButtonText: '去拍照',
        confirmCallback: () => {
          this.toPhoto();
        },
        cancelCallback: () => {
          this.$refs.clickButton.reset();
        }
      });
    },
    showRequiredInfo() {
      const confirmText = '请选择对应的放空原因';
      this.$refs.confirmDialog.open({
        confirmText,
        showCancelButton: false,
        confirmButtonText: '确定',
        confirmCallback: () => {
          this.$refs.clickButton.reset();
        },
        cancelCallback: () => {
          this.$refs.clickButton.reset();
        }
      });
    },
    showInfoConfirm() {
      const confirmObj = [
        {
          key: '类型',
          value: this.productCategoryName
        },
        {
          key: '救援结果',
          value: '现场放空'
        }
      ];
      this.$refs.confirmDialog.open({
        confirmObj,
        cancelButtonText: '返回修改',
        confirmButtonText: '确认提交',
        confirmCallback: () => {
          this.savePictureTemplate();
        },
        cancelCallback: () => {
          this.$refs.clickButton.reset();
        }
      });
    },
    async queryDictByCodes() {
      try {
        const res = await queryDictByCodes({
          codes: [
            'rescueEmptyReason' // 放空原因
          ]
        });
        if (res) {
          this.reasonDataList = res.find(item => item.code === 'rescueEmptyReason').kvs;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async checkPictureNum(noLoading) {
      if (!noLoading) {
        this.$toast.loading({
          message: '正在更新图片数据...',
          forbidClick: true
        });
      }
      const params = {
        useTraceCar: this.useTraceCar,
        pictureTypes: ['011']
      };
      if (!(this.orderNo && this.taskNo)) {
        return;
      }
      try {
        const data = await checkPictureNum({
          orderNo: this.orderNo,
          ...params
        });
        const {
          requiredNum,
          total,
          requiredTips
        } = data || {};
        this.imageCompleted = !isNaN(total) && total === requiredNum;
        this.imageInfo = {
          photoNumTaked: requiredNum,
          photoNumAll: total,
          requiredTips
        };
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async savePictureTemplate(noLoading) {
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        const params = {
          useTraceCar: this.useTraceCar,
          pictureTypes: ['011']
        };
        await savePictureTemplate({
          orderNo: this.orderNo,
          taskNo: this.taskNo,
          ...params
        });
        this.rescueResult();
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    },
    async rescueResult(noLoading) {
      if (!noLoading) {
        this.$toast.loading({
          message: '加载中...',
          forbidClick: true
        });
      }
      try {
        await rescueResult({
          taskNo: this.taskNo,
          rescueResult: 4,
          rescueResultRemark: this.dataForm.evacuationReason
        });
        this.$refs.confirmDialog.close();
        this.$router.replace({
          name: 'executed',
          params: {
            orderNo: this.orderNo,
            taskNo: this.taskNo
          }});
        if (!noLoading) {
          this.$toast.clear();
        }
      } catch (error) {
        console.log(error);
      }
    },
    toPhoto() {
      const params = {
        useTraceCar: this.useTraceCar,
        workerName: this.workerName,
        pictureTypes: ['011']
      };
      params.shopDrawing = this.hasUnderGround ? '1' : '0';
      console.log('toPhoto params:', params);
      this.jumpToNativePage('emptyPhotoPage', params);
      this.$refs.clickButton.reset();
    },
    // 跳转原生页面
    async jumpToNativePage(name, params = {}) {
      try {
        const res = await jsApi.jumpToNativePage({
          name,
          appServiceType: this.appServiceType,
          orderNo: this.orderNo,
          taskNo: this.taskNo,
          ...params
        });
        if (res) {
          console.log(res);
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.wrap-box{
  height: 100vh;
  .top-box{
    overflow-y: auto;

    height: calc(100vh - 82px);

    background: #F2F3F5;
  }
  .bottom{
    height: 82px;
  }
}
.flex-box{
  display: flex;
}
.content-box {
  padding: 12px;
  padding-bottom: 32px;

  .card-box{
    border-radius: 8px;
    background: #FFFFFF;

    & + .card-box{
      margin-top: 12px;
    }

    &.card-padding{
      padding: 16px;
    }

    ::v-deep .card-title,
    .card-title{
      letter-spacing: -0.41px;

      color: #383838;

      font-family: PingFangSC-Medium;
      font-size: 16px;
      font-weight: 500;
      line-height: 22px;

      &.card-title-flex{
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .card-title-info{
        display: flex;
        align-items: center;

        letter-spacing: -0.38px;

        color: #383838;

        font-family: PingFangSC-Regular;
        font-size: 15px;
        font-weight: 400;
        line-height: 21px;

        .van-icon{
          margin-left: 8px;

          color: #999999;

          font-size: 16px;
        }
      }

      .card-tips {
        letter-spacing: -0.38px;

        font-family: PingFangSC-Regular;
        font-size: 15px;
        font-weight: 400;
        line-height: 21px;
        &.card-tips__red {
          color: #F32222;
        }
      }

    }

    .van-button{
      text-align: center;
      letter-spacing: -0.38px;

      color: #FFFFFF;
      border-radius: 8px;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      line-height: 21px;

      &.van-button--info{
        border-color: #3399FF;
        background-color: #3399FF;
      }

      &.van-button--large{
        height: 39px;
      }
    }

    .textarea-box,
    ::v-deep .textarea-box{
      padding: 12px;

      letter-spacing: -0.38px;

      border: 1px solid rgba(200,200,200,1);
      border-radius: 8px;
      background: #FFFFFF;

      font-family: PingFangSC-Regular;
      font-size: 15px;
      font-weight: 400;
      line-height: 21px;

      ::v-deep .van-field__control{
        color: #383838;

        &::placeholder{
          color: #C8C8C8;
        }
      }
    }
  }
  .card-flex{
    display: flex;
    align-items: center;
  }
  .takeImg{
    width: 35px;
    margin-right: 10px;
  }
  .stateInfo{
    margin-right: 10px;
    color: #383838;
    font-weight: 400;
    font-size: 15px;
  }
  .isStateInfo{
    color: #F32222;
  }
}
</style>
